@if (isCollapsed()) {
<div
  class="container"
  [style]="{
    border: '2px solid #e1e8fb',
    'border-radius': '10px',
    padding: '5px',
    marginTop: '5px'
  }"
>
  <div class="row h-4rem align-items-center justify-content-between">
    <div class="col-md-4 col-sm-12">
      <div class="d-flex align-items-center">
        <button
          type="button"
          class="btn btn-primary position-relative program-name text-truncate"
          (click)="toggleCollapse()"
          [id]="'toggleCollapseButton-' + skillArea?.SkillAreaName"
        >
          {{ skillArea?.SkillAreaName }}
        </button>
        @if (skillArea?.IsDeleted) {
        <p-tag
          id="deleted-tag"
          severity="danger"
          value="Deleted"
          class="ms-2"
        />
        }
      </div>
    </div>

    <div class="col-auto">
      <i
        class="pi pi-arrow-down pointer"
        style="font-size: 1rem; color: #719eb6"
        (click)="toggleCollapse()"
      ></i>
    </div>
  </div>
</div>
} @else {
<div
  class="container"
  [style]="{
    border: '2px solid #719eb6',
    'border-radius': '10px',
    padding: '5px',
    marginTop: '5px'
  }"
>
  <div class="row h-4rem align-items-center justify-content-between">
    <div class="col-md-4 col-sm-12">
      <div class="d-flex align-items-center">
        <button
          type="button"
          class="btn btn-primary position-relative program-name text-truncate"
          (click)="toggleCollapse()"
          [id]="'toggleCollapseButton-' + skillArea?.SkillAreaName"
        >
          {{ skillArea?.SkillAreaName }}
        </button>
        @if (skillArea?.IsDeleted) {
        <p-tag
          id="deleted-tag"
          severity="danger"
          value="Deleted"
          class="ms-2"
        />
        }
      </div>
    </div>
    <div class="col-auto">
      <i
        class="pi pi-arrow-up pointer"
        style="font-size: 1rem; color: #719eb6"
        (click)="toggleCollapse()"
      ></i>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div
        class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
      >
        <span class="fw-bold" style="color: #719eb6">Skill Area Name:</span>
        <span class="text-truncate" style="color: #719eb6">
          {{ skillArea?.SkillAreaName }}</span
        >
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div
        class="d-flex flex-wrap align-items-center justify-content-between gap-2 mx-3 my-2"
        id="skillAreaButtons"
      >
        <button
          (click)="editSkillArea()"
          [disabled]="skillArea?.IsDeleted"
          [style.opacity]="skillArea?.IsDeleted ? '0.5' : '1'"
          [style.cursor]="skillArea?.IsDeleted ? 'not-allowed' : 'pointer'"
          class="side-menu-button2 flex-grow-1"
          [id]="'editSkillAreaButton-' + skillArea?.SkillAreaName"
        >
          Edit Skill Area
        </button>
        @if (!skillArea?.IsDeleted) {
          <button
          (click)="deleteSkillArea()"
          [style.opacity]="'1'"
          [style.cursor]="'pointer'"
          class="switch-mode-button flex-grow-1"
          [id]="'deleteSkillAreaButton-' + skillArea?.SkillAreaName"
          >
          Delete Skill Area
        </button>
      } @else {
        <button
        (click)="restoreSkillArea()"
        [style.opacity]="'1'"
        [style.cursor]="'pointer'"
        class="side-menu-button2 flex-grow-1"
        [id]="'restoreSkillAreaButton-' + skillArea?.SkillAreaName"
        >
        Restore Skill Area
      </button>
      }
      </div>
    </div>
  </div>
</div>
}
